import { useEffect } from "react";

import { env } from "@/config";
import { useOrganization } from "@/hooks/useOrganization";
import { useUser } from "@/hooks/useUser";
import { Organization } from "@/types/Organization";
import { User } from "@/types/User";
import Hotjar from "@hotjar/browser";

const isRegularUser = (user: User | null, organization: Organization | null) =>
  user &&
  user.email &&
  !user.is_staff &&
  !user.email.includes("+test") &&
  !user.email.includes("dtdg.co") &&
  !(organization && organization.name && organization.name.includes("datadog"));

export const useHotjar = () => {
  const { data: userData } = useUser();
  const { data: orgData } = useOrganization();

  useEffect(() => {
    const user = userData?.ok ? userData.data : null;
    const organization = orgData?.ok ? orgData.data : null;

    if (env !== "production" || !isRegularUser(user, organization)) return;
    const siteId = 1348302;
    const hotjarVersion = 6;
    Hotjar.init(siteId, hotjarVersion, { debug: false });
    if (user?.email) Hotjar.identify(user.email, { userId: user.email });
  }, [userData, orgData]);

  return Hotjar;
};
